import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'
import styles from './styles.module.scss'

const numberMask = '###-##-####',
  ssnMask = 'xxx-xx-####',
  ssnRegex = /^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/g

class SSNEditor extends Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    withIcon: PropTypes.bool
  }

  static defaultProps = {placeholder: '', withIcon: true}

  constructor(props) {
    super(props)

    const {input: {value: ssn}} = this.props

    if (ssn) {
      this.state = {
        ssn: `xxx-xx-${ssn.substring(5)}`,
        prevSsn: `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(
          5
        )}`,
        mask: ssnMask
      }
    } else {
      this.state = {
        ssn: '',
        prevSsn: '',
        mask: numberMask
      }
    }
  }

  onChangeSSN = e => {
    const {input: {onChange}} = this.props,
      ssn = e.target.value

    onChange(ssn.replace(/x|-|_/g, ''))
    this.setState({ssn})
  }

  onFocus = () => {
    this.setState(prevState => ({ssn: prevState.prevSsn, mask: numberMask}))
  }

  onBlur = () => {
    const {input: {onBlur}} = this.props

    this.setState(prevState => ({
      ssn: prevState.ssn.match(ssnRegex)
        ? `xxx-xx-${prevState.ssn.substring(7)}`
        : prevState.ssn,
      prevSsn: prevState.ssn,
      mask: ssnMask
    }))

    onBlur()
  }

  render() {
    const {
        placeholder,
        meta,
        input,
        id,
        label,
        withIcon,
        ...props
      } = this.props,
      {mask, ssn} = this.state

    return (
      <FormField status={meta} error={meta.error} value={input.value} label={label}>
        <NumberFormat
          mask="_"
          format={mask}
          placeholder={placeholder}
          value={ssn}
          onChange={this.onChangeSSN}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          {...props}
        />
        {withIcon &&
          <div className={styles.securityCheckSign}>
            <i className="cred-icon icon-security-check"/>
          </div>
        }
        <Label htmlFor={id || input.name}>{label}</Label>
      </FormField>
    )
  }
}

export {SSNEditor}
export default SSNEditor
